import {
  FURUI_GET_FRUI_QPGOODS_LIST_BEGIN,
  FURUI_GET_FRUI_QPGOODS_LIST_SUCCESS,
  FURUI_GET_FRUI_QPGOODS_LIST_FAILURE,
  FURUI_GET_FRUI_QPGOODS_LIST_DISMISS_ERROR,
} from './constants';

// import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getFrui_qpgoodsList(params) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: FURUI_GET_FRUI_QPGOODS_LIST_BEGIN,
    });
    params.size = 10;

    const promise = new Promise((resolve, reject) => {
      // request({
      //   method:'post',
      //   url:'/api/b/frui_qpgoods/list',
      //   data:params,
      // }).then( data => {
      dispatch({
        type: FURUI_GET_FRUI_QPGOODS_LIST_SUCCESS,
        data: Object.assign({}, {}, {
          page: params.page, list: [{
            id: 1,
            ph: 'CP1350-21038',
            bh: 'CP1350-21038-002',
            wybh: '199210000396',
            gcrj: '1350',
            zzrq: '2022-02',
            ndsjbh: '4,73',
            nftsjhd: '4.26',
            weight: '590',
            ndttsjhd: '4.73',
            ndzj: '1000',
            ndqysyyl: '2.9',
            dzbs: 'https://qyznoss.oss-cn-hangzhou.aliyuncs.com/igc/2022013013161466147.pdf?Expires=1644388395&OSSAccessKeyId=LTAIzko9W17qtx0R&Signature=VLvuSPabHSE2alLB7xs8aUWwcro%3D',
            gyjt: 'https://qyznoss.oss-cn-hangzhou.aliyuncs.com/igc/2022013013161466147.pdf?Expires=1644388407&OSSAccessKeyId=LTAIzko9W17qtx0R&Signature=%2BZlh46JBPy51VzryiRjlxcpzjMQ%3D',
            hgz: 'https://qyznoss.oss-cn-hangzhou.aliyuncs.com/igc/2021121613584676301.pdf?Expires=1644388418&OSSAccessKeyId=LTAIzko9W17qtx0R&Signature=ZxNcofpex9973qKhAz1iAryZMsY%3D'
          },{
            id: 2,
            ph: 'CP1350-21038',
            bh: 'CP1350-21038-002',
            wybh: '199210000396',
            gcrj: '1350',
            zzrq: '2022-02',
            ndsjbh: '4,73',
            nftsjhd: '4.26',
            weight: '590',
            ndttsjhd: '4.73',
            ndzj: '1000',
            ndqysyyl: '2.9',
            dzbs: 'https://qyznoss.oss-cn-hangzhou.aliyuncs.com/igc/2022013013161466147.pdf?Expires=1644388395&OSSAccessKeyId=LTAIzko9W17qtx0R&Signature=VLvuSPabHSE2alLB7xs8aUWwcro%3D',
            gyjt: 'https://qyznoss.oss-cn-hangzhou.aliyuncs.com/igc/2022013013161466147.pdf?Expires=1644388407&OSSAccessKeyId=LTAIzko9W17qtx0R&Signature=%2BZlh46JBPy51VzryiRjlxcpzjMQ%3D',
            hgz: 'https://qyznoss.oss-cn-hangzhou.aliyuncs.com/igc/2021121613584676301.pdf?Expires=1644388418&OSSAccessKeyId=LTAIzko9W17qtx0R&Signature=ZxNcofpex9973qKhAz1iAryZMsY%3D'
          },{
            id: 3,
            ph: 'CP1350-21038',
            bh: 'CP1350-21038-002',
            wybh: '199210000396',
            gcrj: '1350',
            zzrq: '2022-02',
            ndsjbh: '4,73',
            nftsjhd: '4.26',
            weight: '590',
            ndttsjhd: '4.73',
            ndzj: '1000',
            ndqysyyl: '2.9',
            dzbs: 'https://qyznoss.oss-cn-hangzhou.aliyuncs.com/igc/2022013013161466147.pdf?Expires=1644388395&OSSAccessKeyId=LTAIzko9W17qtx0R&Signature=VLvuSPabHSE2alLB7xs8aUWwcro%3D',
            gyjt: 'https://qyznoss.oss-cn-hangzhou.aliyuncs.com/igc/2022013013161466147.pdf?Expires=1644388407&OSSAccessKeyId=LTAIzko9W17qtx0R&Signature=%2BZlh46JBPy51VzryiRjlxcpzjMQ%3D',
            hgz: 'https://qyznoss.oss-cn-hangzhou.aliyuncs.com/igc/2021121613584676301.pdf?Expires=1644388418&OSSAccessKeyId=LTAIzko9W17qtx0R&Signature=ZxNcofpex9973qKhAz1iAryZMsY%3D'
          }]
        }),
      });
      resolve({});
      //     }).catch (error => {
      //         dispatch({
      //           type: FURUI_GET_FRUI_QPGOODS_LIST_FAILURE,
      //           data: { error: error },
      //         });
      //         reject(error);
      //     })
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetFrui_qpgoodsListError() {
  return {
    type: FURUI_GET_FRUI_QPGOODS_LIST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FURUI_GET_FRUI_QPGOODS_LIST_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getFrui_qpgoodsListPending: true,
        getFrui_qpgoodsListError: null,
      };

    case FURUI_GET_FRUI_QPGOODS_LIST_SUCCESS:
      // The request is success

      const byId = {};
      const items = [];
      action.data.list.forEach(item => {
        items.push(item.id);
        byId[item.id] = item;
      });
      return {
        ...state,
        frui_qpgoodsById: byId,
        frui_qpgoodsList: items,
        frui_qpgoodsPage: 1,
        frui_qpgoodsSize: 10,
        frui_qpgoodsTotal: 11,
        getFrui_qpgoodsListPending: false,
        getFrui_qpgoodsListError: null,
      };

    case FURUI_GET_FRUI_QPGOODS_LIST_FAILURE:
      // The request is failed
      return {
        ...state,
        getFrui_qpgoodsListPending: false,
        getFrui_qpgoodsListError: action.data.error,
      };

    case FURUI_GET_FRUI_QPGOODS_LIST_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getFrui_qpgoodsListError: null,
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/features/furui/redux/getFrui_qpgoodsList.js